// Principales villes des pays proposés au choix du compte (clés de COUNTRY_CURRENCIES).
export const COUNTRY_CITIES: Readonly<Record<string, readonly string[]>> = {
  AO: [
    "Luanda",
    "Huambo",
    "Lobito",
    "Benguela",
    "Lubango",
    "Kuito",
    "Malanje",
    "Namibe",
    "Soyo",
    "Cabinda",
    "Uíge",
    "Saurimo",
    "Sumbe",
    "Menongue",
    "Ondjiva",
    "Caxito",
    "Dundo",
    "N'dalatando",
  ],
  AT: [
    "Vienne",
    "Graz",
    "Linz",
    "Salzbourg",
    "Innsbruck",
    "Klagenfurt",
    "Villach",
    "Wels",
    "Sankt Pölten",
    "Dornbirn",
    "Wiener Neustadt",
    "Steyr",
    "Feldkirch",
    "Bregenz",
    "Leoben",
  ],
  BE: [
    "Bruxelles",
    "Anvers",
    "Gand",
    "Charleroi",
    "Liège",
    "Bruges",
    "Namur",
    "Louvain",
    "Mons",
    "Malines",
    "Alost",
    "La Louvière",
    "Courtrai",
    "Hasselt",
    "Ostende",
    "Tournai",
    "Verviers",
    "Wavre",
    "Louvain-la-Neuve",
    "Arlon",
    "Seraing",
    "Mouscron",
  ],
  BF: [
    "Ouagadougou",
    "Bobo-Dioulasso",
    "Koudougou",
    "Ouahigouya",
    "Banfora",
    "Dédougou",
    "Kaya",
    "Tenkodogo",
    "Fada N'Gourma",
    "Dori",
    "Gaoua",
    "Réo",
    "Ziniaré",
    "Manga",
    "Koupéla",
    "Pouytenga",
    "Kongoussi",
    "Yako",
    "Tougan",
    "Léo",
  ],
  BI: [
    "Bujumbura",
    "Gitega",
    "Ngozi",
    "Rumonge",
    "Muyinga",
    "Kayanza",
    "Ruyigi",
    "Bururi",
    "Makamba",
    "Kirundo",
    "Muramvya",
    "Cibitoke",
    "Bubanza",
    "Rutana",
    "Cankuzo",
    "Karuzi",
  ],
  BJ: [
    "Cotonou",
    "Porto-Novo",
    "Abomey-Calavi",
    "Parakou",
    "Djougou",
    "Bohicon",
    "Natitingou",
    "Abomey",
    "Lokossa",
    "Ouidah",
    "Kandi",
    "Savalou",
    "Sèmè-Kpodji",
    "Malanville",
    "Pobè",
    "Allada",
    "Dassa-Zoumè",
    "Savè",
    "Nikki",
    "Comè",
    "Aplahoué",
    "Bassila",
  ],
  BW: [
    "Gaborone",
    "Francistown",
    "Molepolole",
    "Maun",
    "Serowe",
    "Mogoditshane",
    "Selebi-Phikwe",
    "Kanye",
    "Mahalapye",
    "Palapye",
    "Mochudi",
    "Lobatse",
    "Kasane",
    "Ghanzi",
    "Jwaneng",
    "Orapa",
    "Tlokweng",
    "Ramotswa",
  ],
  CA: [
    "Toronto",
    "Montréal",
    "Vancouver",
    "Calgary",
    "Edmonton",
    "Ottawa",
    "Québec",
    "Winnipeg",
    "Hamilton",
    "Kitchener",
    "London",
    "Halifax",
    "Victoria",
    "Gatineau",
    "Laval",
    "Longueuil",
    "Sherbrooke",
    "Saskatoon",
    "Regina",
    "Trois-Rivières",
    "Moncton",
    "Saint-Jean",
    "Mississauga",
    "Brampton",
    "Windsor",
    "Saguenay",
    "Lévis",
    "Kingston",
  ],
  CD: [
    "Kinshasa",
    "Lubumbashi",
    "Mbuji-Mayi",
    "Kananga",
    "Kisangani",
    "Bukavu",
    "Goma",
    "Kolwezi",
    "Likasi",
    "Tshikapa",
    "Matadi",
    "Mbandaka",
    "Uvira",
    "Butembo",
    "Beni",
    "Kikwit",
    "Boma",
    "Bunia",
    "Kalemie",
    "Kindu",
    "Isiro",
    "Gbadolite",
    "Gemena",
    "Bandundu",
    "Kamina",
    "Muanda",
  ],
  CF: [
    "Bangui",
    "Bimbo",
    "Berbérati",
    "Carnot",
    "Bambari",
    "Bouar",
    "Bossangoa",
    "Bria",
    "Bangassou",
    "Nola",
    "Kaga-Bandoro",
    "Sibut",
    "Mbaïki",
    "Bozoum",
    "Paoua",
    "Batangafo",
    "Ndélé",
    "Obo",
  ],
  CG: [
    "Brazzaville",
    "Pointe-Noire",
    "Dolisie",
    "Nkayi",
    "Owando",
    "Ouesso",
    "Impfondo",
    "Madingou",
    "Sibiti",
    "Gamboma",
    "Djambala",
    "Kinkala",
    "Mossendjo",
    "Ewo",
    "Oyo",
    "Loandjili",
  ],
  CH: [
    "Zurich",
    "Genève",
    "Bâle",
    "Lausanne",
    "Berne",
    "Winterthour",
    "Lucerne",
    "Saint-Gall",
    "Lugano",
    "Bienne",
    "Thoune",
    "Fribourg",
    "Neuchâtel",
    "Sion",
    "La Chaux-de-Fonds",
    "Schaffhouse",
    "Coire",
    "Yverdon-les-Bains",
    "Montreux",
    "Vevey",
    "Nyon",
    "Zoug",
  ],
  CI: [
    "Abidjan",
    "Yamoussoukro",
    "Bouaké",
    "Daloa",
    "San-Pédro",
    "Korhogo",
    "Man",
    "Divo",
    "Gagnoa",
    "Abengourou",
    "Anyama",
    "Agboville",
    "Grand-Bassam",
    "Bingerville",
    "Dabou",
    "Soubré",
    "Séguéla",
    "Odienné",
    "Bondoukou",
    "Dimbokro",
    "Ferkessédougou",
    "Sassandra",
    "Katiola",
    "Toumodi",
    "Issia",
    "Adzopé",
    "Aboisso",
    "Tiassalé",
    "Guiglo",
    "Duékoué",
    "Daoukro",
    "Bouaflé",
    "Sinfra",
    "Jacqueville",
    "Assinie",
  ],
  CM: [
    "Yaoundé",
    "Douala",
    "Garoua",
    "Bamenda",
    "Bafoussam",
    "Maroua",
    "Ngaoundéré",
    "Bertoua",
    "Buea",
    "Limbé",
    "Kribi",
    "Ebolowa",
    "Kumba",
    "Nkongsamba",
    "Edéa",
    "Dschang",
    "Foumban",
    "Mbouda",
    "Bafang",
    "Bangangté",
    "Loum",
    "Sangmélima",
    "Mbalmayo",
    "Obala",
    "Tiko",
    "Kousséri",
    "Guider",
    "Meiganga",
    "Batouri",
    "Abong-Mbang",
    "Mokolo",
    "Yagoua",
    "Kaélé",
    "Tibati",
    "Wum",
    "Kumbo",
    "Mamfe",
    "Bafia",
    "Akonolinga",
    "Manjo",
    "Mbanga",
    "Penja",
    "Foumbot",
  ],
  CV: [
    "Praia",
    "Mindelo",
    "Santa Maria",
    "Assomada",
    "Espargos",
    "Pedra Badejo",
    "São Filipe",
    "Porto Novo",
    "Tarrafal",
    "Ribeira Grande",
    "Sal Rei",
    "Calheta de São Miguel",
  ],
  DE: [
    "Berlin",
    "Hambourg",
    "Munich",
    "Cologne",
    "Francfort-sur-le-Main",
    "Stuttgart",
    "Düsseldorf",
    "Leipzig",
    "Dortmund",
    "Essen",
    "Brême",
    "Dresde",
    "Hanovre",
    "Nuremberg",
    "Duisbourg",
    "Bochum",
    "Wuppertal",
    "Bielefeld",
    "Bonn",
    "Münster",
    "Mannheim",
    "Karlsruhe",
    "Augsbourg",
    "Wiesbaden",
    "Aix-la-Chapelle",
    "Kiel",
    "Fribourg-en-Brisgau",
    "Mayence",
    "Heidelberg",
  ],
  DJ: [
    "Djibouti",
    "Ali Sabieh",
    "Tadjourah",
    "Obock",
    "Dikhil",
    "Arta",
    "Holhol",
    "Yoboki",
    "Galafi",
    "Balho",
  ],
  DZ: [
    "Alger",
    "Oran",
    "Constantine",
    "Annaba",
    "Blida",
    "Batna",
    "Sétif",
    "Djelfa",
    "Sidi Bel Abbès",
    "Biskra",
    "Tébessa",
    "Tlemcen",
    "Béjaïa",
    "Tiaret",
    "Tizi Ouzou",
    "Ouargla",
    "Bordj Bou Arréridj",
    "Chlef",
    "Skikda",
    "Mostaganem",
    "Médéa",
    "Béchar",
    "El Oued",
    "Ghardaïa",
    "Jijel",
    "Mascara",
    "Boumerdès",
    "Tamanrasset",
    "Laghouat",
    "Guelma",
  ],
  EG: [
    "Le Caire",
    "Alexandrie",
    "Gizeh",
    "Shubra El Kheima",
    "Port-Saïd",
    "Suez",
    "Louxor",
    "Assouan",
    "Mansourah",
    "Tanta",
    "Assiout",
    "Ismaïlia",
    "Fayoum",
    "Zagazig",
    "Damiette",
    "Minya",
    "Hurghada",
    "Charm el-Cheikh",
    "Beni Suef",
    "Sohag",
    "Qena",
    "Marsa Matruh",
    "Nouveau Caire",
    "6-Octobre",
  ],
  ER: [
    "Asmara",
    "Keren",
    "Massaoua",
    "Assab",
    "Mendefera",
    "Barentu",
    "Adi Keyh",
    "Dekemhare",
    "Ak'ordat",
    "Nakfa",
    "Tessenei",
  ],
  ES: [
    "Madrid",
    "Barcelone",
    "Valence",
    "Séville",
    "Saragosse",
    "Malaga",
    "Murcie",
    "Palma",
    "Las Palmas de Gran Canaria",
    "Bilbao",
    "Alicante",
    "Cordoue",
    "Valladolid",
    "Vigo",
    "Gijón",
    "Grenade",
    "La Corogne",
    "Vitoria-Gasteiz",
    "Santa Cruz de Tenerife",
    "Pampelune",
    "Saint-Sébastien",
    "Santander",
    "Salamanque",
    "Tolède",
    "Cadix",
    "Tarragone",
    "Gérone",
  ],
  ET: [
    "Addis-Abeba",
    "Dire Dawa",
    "Mekele",
    "Gondar",
    "Adama",
    "Hawassa",
    "Bahir Dar",
    "Dessie",
    "Jimma",
    "Jijiga",
    "Shashamané",
    "Bishoftu",
    "Harar",
    "Sodo",
    "Arba Minch",
    "Hosaena",
    "Dilla",
    "Nekemte",
    "Debre Birhan",
    "Asella",
    "Gambela",
    "Semera",
  ],
  FI: [
    "Helsinki",
    "Espoo",
    "Tampere",
    "Vantaa",
    "Oulu",
    "Turku",
    "Jyväskylä",
    "Lahti",
    "Kuopio",
    "Pori",
    "Kouvola",
    "Joensuu",
    "Lappeenranta",
    "Hämeenlinna",
    "Vaasa",
    "Seinäjoki",
    "Rovaniemi",
    "Kotka",
  ],
  FR: [
    "Paris",
    "Marseille",
    "Lyon",
    "Toulouse",
    "Nice",
    "Nantes",
    "Montpellier",
    "Strasbourg",
    "Bordeaux",
    "Lille",
    "Rennes",
    "Reims",
    "Toulon",
    "Saint-Étienne",
    "Le Havre",
    "Grenoble",
    "Dijon",
    "Angers",
    "Nîmes",
    "Villeurbanne",
    "Clermont-Ferrand",
    "Le Mans",
    "Aix-en-Provence",
    "Brest",
    "Tours",
    "Amiens",
    "Limoges",
    "Annecy",
    "Perpignan",
    "Metz",
    "Besançon",
    "Orléans",
    "Rouen",
    "Mulhouse",
    "Caen",
    "Nancy",
    "Argenteuil",
    "Saint-Denis",
    "Montreuil",
    "Boulogne-Billancourt",
    "Nanterre",
    "Créteil",
    "Versailles",
    "Avignon",
    "Poitiers",
    "La Rochelle",
    "Pau",
    "Cergy",
    "Évry-Courcouronnes",
    "Saint-Denis (La Réunion)",
    "Fort-de-France",
    "Pointe-à-Pitre",
    "Cayenne",
    "Mamoudzou",
  ],
  GA: [
    "Libreville",
    "Port-Gentil",
    "Franceville",
    "Oyem",
    "Moanda",
    "Mouila",
    "Lambaréné",
    "Tchibanga",
    "Koulamoutou",
    "Makokou",
    "Bitam",
    "Owendo",
    "Akanda",
    "Ntoum",
    "Gamba",
    "Mounana",
    "Lastoursville",
    "Ndendé",
    "Booué",
    "Mitzic",
    "Fougamou",
    "Okondja",
  ],
  GH: [
    "Accra",
    "Kumasi",
    "Tamale",
    "Sekondi-Takoradi",
    "Ashaiman",
    "Sunyani",
    "Cape Coast",
    "Obuasi",
    "Teshie",
    "Tema",
    "Madina",
    "Koforidua",
    "Wa",
    "Techiman",
    "Ho",
    "Bolgatanga",
    "Nkawkaw",
    "Winneba",
    "Tarkwa",
    "Kasoa",
    "Aflao",
    "Dambai",
    "Goaso",
    "Sefwi Wiawso",
  ],
  GM: [
    "Banjul",
    "Serekunda",
    "Brikama",
    "Bakau",
    "Farafenni",
    "Lamin",
    "Sukuta",
    "Basse Santa Su",
    "Gunjur",
    "Soma",
    "Janjanbureh",
    "Kerewan",
    "Mansa Konko",
    "Kuntaur",
  ],
  GN: [
    "Conakry",
    "Nzérékoré",
    "Kankan",
    "Kindia",
    "Kamsar",
    "Labé",
    "Mamou",
    "Boké",
    "Siguiri",
    "Guéckédou",
    "Macenta",
    "Faranah",
    "Kissidougou",
    "Dubréka",
    "Coyah",
    "Fria",
    "Kouroussa",
    "Pita",
    "Dalaba",
    "Télimélé",
    "Beyla",
    "Lola",
    "Dabola",
    "Boffa",
  ],
  GQ: [
    "Malabo",
    "Bata",
    "Ebebiyín",
    "Mongomo",
    "Aconibe",
    "Añisoc",
    "Luba",
    "Evinayong",
    "Mbini",
    "Ciudad de la Paz",
    "Cogo",
    "Mikomeseng",
    "Niefang",
    "Riaba",
  ],
  GR: [
    "Athènes",
    "Thessalonique",
    "Le Pirée",
    "Patras",
    "Héraklion",
    "Larissa",
    "Volos",
    "Ioannina",
    "La Canée",
    "Chalcis",
    "Sérrès",
    "Alexandroúpoli",
    "Kalamata",
    "Kavala",
    "Rhodes",
    "Corfou",
    "Tríkala",
    "Lamía",
  ],
  GW: [
    "Bissau",
    "Bafatá",
    "Gabú",
    "Bissorã",
    "Bolama",
    "Cacheu",
    "Bubaque",
    "Catió",
    "Mansôa",
    "Buba",
    "Canchungo",
    "Farim",
    "Quinhámel",
    "São Domingos",
  ],
  HT: [
    "Port-au-Prince",
    "Carrefour",
    "Delmas",
    "Pétion-Ville",
    "Cap-Haïtien",
    "Gonaïves",
    "Saint-Marc",
    "Les Cayes",
    "Jacmel",
    "Port-de-Paix",
    "Jérémie",
    "Hinche",
    "Fort-Liberté",
    "Miragoâne",
    "Croix-des-Bouquets",
    "Léogâne",
    "Petit-Goâve",
    "Ouanaminthe",
    "Mirebalais",
  ],
  IE: [
    "Dublin",
    "Cork",
    "Limerick",
    "Galway",
    "Waterford",
    "Drogheda",
    "Swords",
    "Dundalk",
    "Bray",
    "Navan",
    "Kilkenny",
    "Ennis",
    "Carlow",
    "Tralee",
    "Newbridge",
    "Portlaoise",
    "Athlone",
    "Sligo",
    "Letterkenny",
    "Wexford",
  ],
  IT: [
    "Rome",
    "Milan",
    "Naples",
    "Turin",
    "Palerme",
    "Gênes",
    "Bologne",
    "Florence",
    "Bari",
    "Catane",
    "Venise",
    "Vérone",
    "Messine",
    "Padoue",
    "Trieste",
    "Tarente",
    "Brescia",
    "Parme",
    "Prato",
    "Modène",
    "Reggio de Calabre",
    "Pérouse",
    "Livourne",
    "Cagliari",
    "Bergame",
    "Pise",
    "Salerne",
    "Trente",
    "Bolzano",
  ],
  KE: [
    "Nairobi",
    "Mombasa",
    "Kisumu",
    "Nakuru",
    "Eldoret",
    "Ruiru",
    "Kikuyu",
    "Thika",
    "Malindi",
    "Kitale",
    "Machakos",
    "Garissa",
    "Kakamega",
    "Nyeri",
    "Meru",
    "Kericho",
    "Naivasha",
    "Kisii",
    "Embu",
    "Lamu",
    "Nanyuki",
    "Bungoma",
    "Busia",
    "Voi",
    "Lodwar",
  ],
  KM: [
    "Moroni",
    "Mutsamudu",
    "Fomboni",
    "Domoni",
    "Tsémbéhou",
    "Mitsamiouli",
    "Ouani",
    "Sima",
    "Mbéni",
    "Foumbouni",
    "Iconi",
    "Mirontsy",
  ],
  LB: [
    "Beyrouth",
    "Tripoli",
    "Saïda",
    "Tyr",
    "Jounieh",
    "Zahlé",
    "Baalbek",
    "Byblos",
    "Nabatieh",
    "Baabda",
    "Aley",
    "Batroun",
    "Halba",
    "Jdeideh",
    "Zgharta",
    "Bcharré",
  ],
  LR: [
    "Monrovia",
    "Gbarnga",
    "Kakata",
    "Bensonville",
    "Harper",
    "Voinjama",
    "Buchanan",
    "Zwedru",
    "Ganta",
    "Robertsport",
    "Sanniquellie",
    "Tubmanburg",
    "Greenville",
    "Barclayville",
    "Fish Town",
    "Cestos City",
  ],
  LS: [
    "Maseru",
    "Teyateyaneng",
    "Mafeteng",
    "Hlotse",
    "Mohale's Hoek",
    "Maputsoe",
    "Qacha's Nek",
    "Quthing",
    "Butha-Buthe",
    "Mokhotlong",
    "Thaba-Tseka",
    "Roma",
    "Morija",
  ],
  LU: [
    "Luxembourg",
    "Esch-sur-Alzette",
    "Differdange",
    "Dudelange",
    "Ettelbruck",
    "Diekirch",
    "Wiltz",
    "Echternach",
    "Rumelange",
    "Grevenmacher",
    "Remich",
    "Vianden",
    "Strassen",
    "Bertrange",
    "Mamer",
    "Hesperange",
    "Sanem",
    "Pétange",
    "Mersch",
    "Clervaux",
  ],
  LY: [
    "Tripoli",
    "Benghazi",
    "Misrata",
    "Zliten",
    "Bayda",
    "Zawiya",
    "Ajdabiya",
    "Tobrouk",
    "Sabha",
    "Syrte",
    "Khoms",
    "Derna",
    "Gharyan",
    "Sabratha",
    "Zouara",
    "Marj",
    "Ghat",
    "Ubari",
  ],
  MA: [
    "Casablanca",
    "Rabat",
    "Fès",
    "Marrakech",
    "Tanger",
    "Agadir",
    "Meknès",
    "Oujda",
    "Kénitra",
    "Tétouan",
    "Salé",
    "Témara",
    "Safi",
    "Mohammédia",
    "Khouribga",
    "El Jadida",
    "Béni Mellal",
    "Nador",
    "Taza",
    "Settat",
    "Berrechid",
    "Khémisset",
    "Inezgane",
    "Ksar El Kébir",
    "Larache",
    "Guelmim",
    "Errachidia",
    "Ouarzazate",
    "Laâyoune",
    "Dakhla",
    "Essaouira",
    "Ifrane",
  ],
  MC: ["Monaco", "Monte-Carlo", "La Condamine", "Fontvieille", "Monaco-Ville", "Larvotto"],
  MG: [
    "Antananarivo",
    "Toamasina",
    "Antsirabe",
    "Mahajanga",
    "Fianarantsoa",
    "Toliara",
    "Antsiranana",
    "Ambovombe",
    "Antanifotsy",
    "Ambositra",
    "Morondava",
    "Manakara",
    "Sambava",
    "Nosy Be",
    "Fort-Dauphin",
    "Ambatondrazaka",
    "Moramanga",
    "Antalaha",
    "Farafangana",
    "Maintirano",
    "Ihosy",
    "Miarinarivo",
  ],
  ML: [
    "Bamako",
    "Sikasso",
    "Ségou",
    "Mopti",
    "Koutiala",
    "Kayes",
    "Gao",
    "Kati",
    "San",
    "Kita",
    "Koulikoro",
    "Tombouctou",
    "Bougouni",
    "Djenné",
    "Kidal",
    "Nioro du Sahel",
    "Fana",
    "Bandiagara",
    "Kolokani",
    "Ménaka",
    "Bla",
    "Kadiolo",
    "Diré",
    "Niono",
  ],
  MR: [
    "Nouakchott",
    "Nouadhibou",
    "Kiffa",
    "Kaédi",
    "Zouérate",
    "Rosso",
    "Atar",
    "Néma",
    "Sélibaby",
    "Aleg",
    "Boutilimit",
    "Akjoujt",
    "Tidjikja",
    "Aïoun",
    "Bogué",
    "Chinguetti",
  ],
  MU: [
    "Port-Louis",
    "Beau-Bassin Rose-Hill",
    "Vacoas-Phoenix",
    "Curepipe",
    "Quatre Bornes",
    "Triolet",
    "Goodlands",
    "Centre de Flacq",
    "Mahébourg",
    "Saint-Pierre",
    "Grand Baie",
    "Ébène",
    "Moka",
    "Rivière du Rempart",
    "Bel Air",
    "Pamplemousses",
    "Tamarin",
    "Port Mathurin",
  ],
  MW: [
    "Lilongwe",
    "Blantyre",
    "Mzuzu",
    "Zomba",
    "Kasungu",
    "Mangochi",
    "Karonga",
    "Salima",
    "Nkhotakota",
    "Liwonde",
    "Balaka",
    "Dedza",
    "Nsanje",
    "Mchinji",
    "Rumphi",
    "Mulanje",
    "Nkhata Bay",
    "Chitipa",
  ],
  MZ: [
    "Maputo",
    "Matola",
    "Beira",
    "Nampula",
    "Chimoio",
    "Nacala",
    "Quelimane",
    "Tete",
    "Xai-Xai",
    "Lichinga",
    "Pemba",
    "Inhambane",
    "Maxixe",
    "Gurúè",
    "Montepuez",
    "Dondo",
    "Cuamba",
    "Angoche",
    "Vilankulo",
    "Mocuba",
    "Chókwè",
  ],
  NA: [
    "Windhoek",
    "Rundu",
    "Walvis Bay",
    "Swakopmund",
    "Oshakati",
    "Rehoboth",
    "Katima Mulilo",
    "Otjiwarongo",
    "Ondangwa",
    "Okahandja",
    "Keetmanshoop",
    "Tsumeb",
    "Grootfontein",
    "Gobabis",
    "Lüderitz",
    "Mariental",
    "Outapi",
    "Ongwediva",
    "Opuwo",
  ],
  NC: [
    "Nouméa",
    "Dumbéa",
    "Le Mont-Dore",
    "Païta",
    "Koné",
    "Bourail",
    "Koumac",
    "Poindimié",
    "La Foa",
    "Houaïlou",
    "Thio",
    "Canala",
    "Lifou",
    "Maré",
    "Ouvéa",
    "Voh",
    "Poya",
  ],
  NE: [
    "Niamey",
    "Zinder",
    "Maradi",
    "Agadez",
    "Tahoua",
    "Dosso",
    "Diffa",
    "Tillabéri",
    "Arlit",
    "Birni-N'Konni",
    "Gaya",
    "Tessaoua",
    "Dogondoutchi",
    "Madaoua",
    "Mirriah",
    "Magaria",
    "Ayorou",
    "Filingué",
    "Téra",
    "Tchirozérine",
  ],
  NG: [
    "Lagos",
    "Abuja",
    "Kano",
    "Ibadan",
    "Port Harcourt",
    "Benin City",
    "Kaduna",
    "Onitsha",
    "Aba",
    "Maiduguri",
    "Ilorin",
    "Jos",
    "Enugu",
    "Abeokuta",
    "Owerri",
    "Uyo",
    "Calabar",
    "Warri",
    "Akure",
    "Sokoto",
    "Zaria",
    "Osogbo",
    "Yola",
    "Bauchi",
    "Ikeja",
    "Lekki",
    "Asaba",
    "Makurdi",
    "Minna",
    "Lokoja",
    "Ado-Ekiti",
    "Abakaliki",
    "Umuahia",
    "Awka",
    "Gombe",
    "Katsina",
    "Ota",
    "Ife",
  ],
  NL: [
    "Amsterdam",
    "Rotterdam",
    "La Haye",
    "Utrecht",
    "Eindhoven",
    "Groningue",
    "Tilbourg",
    "Almere",
    "Breda",
    "Nimègue",
    "Apeldoorn",
    "Haarlem",
    "Arnhem",
    "Enschede",
    "Amersfoort",
    "Zaanstad",
    "Bois-le-Duc",
    "Zwolle",
    "Leyde",
    "Maastricht",
    "Dordrecht",
    "Delft",
  ],
  PF: [
    "Papeete",
    "Faaa",
    "Punaauia",
    "Pirae",
    "Mahina",
    "Paea",
    "Arue",
    "Papara",
    "Moorea-Maiao",
    "Taiarapu-Est",
    "Teva I Uta",
    "Bora-Bora",
    "Uturoa",
    "Raiatea",
    "Huahine",
    "Nuku Hiva",
    "Rangiroa",
  ],
  PT: [
    "Lisbonne",
    "Porto",
    "Vila Nova de Gaia",
    "Amadora",
    "Braga",
    "Coimbra",
    "Funchal",
    "Setúbal",
    "Almada",
    "Aveiro",
    "Faro",
    "Leiria",
    "Évora",
    "Viseu",
    "Guimarães",
    "Matosinhos",
    "Sintra",
    "Cascais",
    "Oeiras",
    "Ponta Delgada",
    "Portimão",
    "Viana do Castelo",
    "Castelo Branco",
  ],
  RW: [
    "Kigali",
    "Huye",
    "Musanze",
    "Rubavu",
    "Muhanga",
    "Rusizi",
    "Nyagatare",
    "Rwamagana",
    "Byumba",
    "Kibuye",
    "Nyanza",
    "Kayonza",
    "Kirehe",
    "Ngoma",
    "Nyamata",
    "Bugesera",
  ],
  SC: [
    "Victoria",
    "Anse Boileau",
    "Beau Vallon",
    "Anse Royale",
    "Takamaka",
    "Baie Lazare",
    "Cascade",
    "Bel Ombre",
    "Grand'Anse Praslin",
    "Baie Sainte Anne",
    "La Digue",
    "Port Glaud",
  ],
  SD: [
    "Khartoum",
    "Omdourman",
    "Port-Soudan",
    "Kassala",
    "El Obeid",
    "Nyala",
    "Wad Madani",
    "El Fasher",
    "Gedaref",
    "Kosti",
    "Atbara",
    "Dongola",
    "Sennar",
    "El Geneina",
    "Rabak",
    "Kadugli",
    "Ed Damazin",
    "Shendi",
  ],
  SL: [
    "Freetown",
    "Bo",
    "Kenema",
    "Makeni",
    "Koidu",
    "Lunsar",
    "Port Loko",
    "Waterloo",
    "Kabala",
    "Kailahun",
    "Magburaka",
    "Bonthe",
    "Moyamba",
    "Pujehun",
    "Kambia",
    "Lungi",
  ],
  SN: [
    "Dakar",
    "Touba",
    "Thiès",
    "Rufisque",
    "Kaolack",
    "Mbour",
    "Saint-Louis",
    "Ziguinchor",
    "Diourbel",
    "Pikine",
    "Guédiawaye",
    "Louga",
    "Tambacounda",
    "Kolda",
    "Richard-Toll",
    "Mbacké",
    "Tivaouane",
    "Fatick",
    "Kaffrine",
    "Kédougou",
    "Matam",
    "Sédhiou",
    "Joal-Fadiouth",
    "Saly",
    "Diamniadio",
    "Bargny",
    "Podor",
    "Linguère",
    "Bambey",
    "Vélingara",
  ],
  SO: [
    "Mogadiscio",
    "Hargeisa",
    "Bosaso",
    "Kismayo",
    "Baidoa",
    "Berbera",
    "Galkayo",
    "Beledweyne",
    "Garowe",
    "Burao",
    "Merca",
    "Jowhar",
    "Afgooye",
    "Borama",
    "Las Anod",
    "Dhusamareb",
  ],
  SS: [
    "Djouba",
    "Wau",
    "Malakal",
    "Yei",
    "Aweil",
    "Rumbek",
    "Bor",
    "Torit",
    "Kuajok",
    "Bentiu",
    "Yambio",
    "Nimule",
    "Renk",
    "Kapoeta",
    "Maridi",
  ],
  ST: [
    "São Tomé",
    "Santo Amaro",
    "Neves",
    "Santana",
    "Trindade",
    "Guadalupe",
    "Santo António",
    "São João dos Angolares",
    "Pantufo",
    "Porto Alegre",
  ],
  SZ: [
    "Mbabane",
    "Manzini",
    "Lobamba",
    "Siteki",
    "Nhlangano",
    "Piggs Peak",
    "Matsapha",
    "Big Bend",
    "Hlatikulu",
    "Simunye",
    "Mhlume",
    "Lavumisa",
    "Ezulwini",
  ],
  TD: [
    "N'Djaména",
    "Moundou",
    "Abéché",
    "Sarh",
    "Kélo",
    "Am Timan",
    "Doba",
    "Pala",
    "Bongor",
    "Mongo",
    "Ati",
    "Koumra",
    "Faya-Largeau",
    "Mao",
    "Laï",
    "Moussoro",
    "Bol",
    "Massakory",
    "Biltine",
    "Goz Beïda",
  ],
  TG: [
    "Lomé",
    "Sokodé",
    "Kara",
    "Kpalimé",
    "Atakpamé",
    "Dapaong",
    "Tsévié",
    "Aného",
    "Bassar",
    "Notsé",
    "Mango",
    "Badou",
    "Tabligbo",
    "Vogan",
    "Kandé",
    "Bafilo",
    "Sotouboua",
    "Niamtougou",
    "Blitta",
    "Agoè-Nyivé",
    "Baguida",
  ],
  TN: [
    "Tunis",
    "Sfax",
    "Sousse",
    "Kairouan",
    "Bizerte",
    "Gabès",
    "Ariana",
    "Gafsa",
    "Monastir",
    "Ben Arous",
    "La Marsa",
    "Kasserine",
    "Médenine",
    "Nabeul",
    "Hammamet",
    "Mahdia",
    "Tataouine",
    "Béja",
    "Jendouba",
    "Le Kef",
    "Tozeur",
    "Djerba",
    "Zarzis",
    "Siliana",
    "Kélibia",
  ],
  TZ: [
    "Dar es Salaam",
    "Dodoma",
    "Mwanza",
    "Arusha",
    "Mbeya",
    "Morogoro",
    "Tanga",
    "Zanzibar",
    "Kigoma",
    "Moshi",
    "Tabora",
    "Songea",
    "Musoma",
    "Iringa",
    "Shinyanga",
    "Mtwara",
    "Bukoba",
    "Singida",
    "Sumbawanga",
    "Lindi",
  ],
  UG: [
    "Kampala",
    "Gulu",
    "Lira",
    "Mbarara",
    "Jinja",
    "Mbale",
    "Entebbe",
    "Masaka",
    "Mukono",
    "Kasese",
    "Arua",
    "Fort Portal",
    "Soroti",
    "Hoima",
    "Kabale",
    "Tororo",
    "Wakiso",
    "Iganga",
    "Busia",
    "Moroto",
  ],
  US: [
    "New York",
    "Los Angeles",
    "Chicago",
    "Houston",
    "Phoenix",
    "Philadelphie",
    "San Antonio",
    "San Diego",
    "Dallas",
    "Austin",
    "San José",
    "Jacksonville",
    "Columbus",
    "Charlotte",
    "Indianapolis",
    "San Francisco",
    "Seattle",
    "Denver",
    "Washington",
    "Boston",
    "Nashville",
    "Detroit",
    "Las Vegas",
    "Portland",
    "Atlanta",
    "Miami",
    "Minneapolis",
    "Baltimore",
    "La Nouvelle-Orléans",
    "Pittsburgh",
    "Raleigh",
    "Salt Lake City",
    "Orlando",
    "Newark",
  ],
  VU: [
    "Port-Vila",
    "Luganville",
    "Norsup",
    "Isangel",
    "Lakatoro",
    "Sola",
    "Saratamata",
    "Lenakel",
    "Longana",
  ],
  WF: ["Mata-Utu", "Leava", "Alele", "Vailala", "Sigave", "Alo", "Liku", "Mala'e"],
  ZA: [
    "Johannesburg",
    "Le Cap",
    "Durban",
    "Pretoria",
    "Port Elizabeth",
    "Bloemfontein",
    "East London",
    "Soweto",
    "Pietermaritzburg",
    "Polokwane",
    "Mbombela",
    "Kimberley",
    "Rustenburg",
    "George",
    "Stellenbosch",
    "Centurion",
    "Sandton",
    "Midrand",
    "Benoni",
    "Germiston",
    "Vereeniging",
    "Welkom",
    "Mahikeng",
    "Richards Bay",
    "Upington",
  ],
  ZM: [
    "Lusaka",
    "Kitwe",
    "Ndola",
    "Kabwe",
    "Chingola",
    "Mufulira",
    "Livingstone",
    "Luanshya",
    "Chipata",
    "Kasama",
    "Solwezi",
    "Mansa",
    "Mongu",
    "Choma",
    "Kafue",
    "Mazabuka",
    "Kalulushi",
    "Chililabombwe",
  ],
  ZW: [
    "Harare",
    "Bulawayo",
    "Chitungwiza",
    "Mutare",
    "Epworth",
    "Gweru",
    "Kwekwe",
    "Kadoma",
    "Masvingo",
    "Chinhoyi",
    "Marondera",
    "Norton",
    "Chegutu",
    "Bindura",
    "Victoria Falls",
    "Hwange",
    "Kariba",
    "Beitbridge",
    "Rusape",
    "Zvishavane",
  ],
};

// Proposées quand le compte n'a pas de pays renseigné.
export const GENERIC_CITIES: readonly string[] = [
  "Abidjan",
  "Abuja",
  "Accra",
  "Addis-Abeba",
  "Alger",
  "Antananarivo",
  "Bamako",
  "Bangui",
  "Bafoussam",
  "Bamenda",
  "Bruxelles",
  "Bujumbura",
  "Brazzaville",
  "Casablanca",
  "Conakry",
  "Cotonou",
  "Dakar",
  "Dar es Salaam",
  "Douala",
  "Dschang",
  "Freetown",
  "Garoua",
  "Genève",
  "Johannesburg",
  "Kampala",
  "Kigali",
  "Kinshasa",
  "Lagos",
  "Le Caire",
  "Libreville",
  "Lomé",
  "Luanda",
  "Lubumbashi",
  "Lyon",
  "Malabo",
  "Montréal",
  "N'Djaména",
  "Nairobi",
  "Niamey",
  "Nouakchott",
  "Ouagadougou",
  "Paris",
  "Pointe-Noire",
  "Port-Louis",
  "Porto-Novo",
  "Rabat",
  "Tunis",
  "Yaoundé",
];

export const getCountryCities = (countryCode?: string | null): readonly string[] =>
  (countryCode && COUNTRY_CITIES[countryCode.toUpperCase()]) || GENERIC_CITIES;
